import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    position: "relative",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#e5e5e5",
    paddingVertical: 40,
  },
  certificateCard: {
    zIndex: 1,
    width: "95%",
    backgroundColor: "#fff",
    padding: 40,
    borderRadius: 8,
    borderWidth: 2,
    borderColor: "#077A97",
  },

  columnsContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 20,
  },
  leftColumn: {
    width: "48%",
  },
  rightColumn: {
    width: "48%",
  },
  userNameHighlight: {
    fontSize: 28,
    fontWeight: "bold",
    color: "#077A97",
    textAlign: "center",
    marginVertical: 16,
  },
  title: {
    fontSize: 32,
    color: "#077A97",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 20,
  },
  subtitle: {
    fontSize: 16,
    textAlign: "justify",
    marginBottom: 24,
    lineHeight: 24,
  },
  assetList: {
    alignSelf: "flex-start",
    marginBottom: 20,
  },
  assetText: {
    marginBottom: 4,
    fontSize: 14,
    color: "#000",
  },

  qrCodeText: {
    marginTop: 10,
    fontSize: 12,
    color: "#666",
  },

  fixedQRCode: {
    position: "absolute",
    right: 15,
    zIndex: 10,
    borderRadius: 8,
  },

  assetAmount: {
    fontSize: 14,
    color: "#077A97",
    fontWeight: "bold",
  },
  signatureContainer: {
    gap: 20,
    flexDirection: "row",
    marginTop: 40,
  },
  signatureColumn: {
    flexDirection: "column",
    alignItems: "center",
  },
  signatureImage: {
    width: 180,
    height: 60,
    resizeMode: "contain",
  },
  signatureLine: {
    height: 1,
    backgroundColor: "transparent",
    width: "100%",
    borderWidth: 0,
    borderTopWidth: 1,
    borderTopColor: "#aaa",
  },
  logoImage: {
    width: 140,
    height: 60,
    resizeMode: "contain",
  },
  footer: {
    fontSize: 14,
    color: "#777",
    textAlign: "center",
    marginTop: 2,
  },
  button: {
    backgroundColor: "#077A97",
    padding: 16,
    borderRadius: 10,
    marginTop: 30,
    alignItems: "center",
    alignSelf: "stretch",
  },
  buttonText: {
    color: "#fff",
    fontWeight: "bold",
    fontSize: 18,
  },
  btnVoltar: {
    marginTop: 20,
    padding: 10,
    width: 320,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: "#077A97",
    backgroundColor: "#FFF",
    marginBottom: 20,
    alignSelf: "center",
  },
  btnVoltarText: {
    fontSize: 18,
    color: "#077A97",
    textTransform: "uppercase",
  },

  verticalDivider: {
    height: "100%",
    borderLeftWidth: 1,
    borderLeftColor: "#ccc",
    borderStyle: "solid",
    marginHorizontal: 16,
  },

  documentoText: {
    textAlign: "center",
    marginTop: 4,
    fontSize: 14,
    color: "#666",
  },

  blockchainHash: {
    fontWeight: "bold",
    color: "#333",
  },
  hashValue: {
    color: "#666",
  },

  boldText: {
    fontWeight: "bold",
  },

  rowInfo: {
    flexDirection: "row",
    alignItems: "center",
  },

  bgIcone: {
    position: "absolute",
    top: 10,
    right: 10,
    width: 80,
    height: 80,
    zIndex: 9999,
    resizeMode: "contain",
    opacity: 0.8,
  },
});
export default styles;
